import { render, staticRenderFns } from "./CompPopup.vue?vue&type=template&id=650bd64e&"
import script from "./CompPopup.vue?vue&type=script&lang=js&"
export * from "./CompPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports